import { Button, Group, Modal, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

type ImportConfirmModalProps = {
  opened: boolean;
  newCount: number;
  updateCount: number;
  deleteCount?: number;
  entityKey: string;
  onConfirm: () => void;
  onCancel: () => void;
};

export function ImportConfirmModal({
  opened,
  newCount,
  updateCount,
  deleteCount = 0,
  entityKey,
  onConfirm,
  onCancel,
}: ImportConfirmModalProps) {
  const { t } = useTranslation();
  const entity = t(`common.import.entities.${entityKey}`);

  return (
    <Modal
      opened={opened}
      onClose={onCancel}
      title={t('common.import.confirmTitle')}
      centered
    >
      <Text size="sm" mb="lg">
        {deleteCount > 0
          ? t('common.import.confirmMessageWithDeletes', {
              newCount,
              updateCount,
              deleteCount,
              entity,
            })
          : t('common.import.confirmMessage', {
              newCount,
              updateCount,
              entity,
            })}
      </Text>
      <Group position="right">
        <Button variant="default" onClick={onCancel}>
          {t('common.cancel')}
        </Button>
        <Button onClick={onConfirm}>{t('common.confirm')}</Button>
      </Group>
    </Modal>
  );
}
